import { styled, Switch, switchClasses } from '@mui/material';
import { HBSwitchRootStyleProps } from '@/core/ui/HBSwitch/type';

export const HBSwitchRootStyle = styled(Switch, {
  shouldForwardProp: (prop) =>
    prop !== 'checkedColor' && prop !== 'uncheckedColor' && prop !== 'disabledColor',
})<HBSwitchRootStyleProps>(({ theme, checkedColor, uncheckedColor, disabledColor }) => {
  const checkedBgColor = checkedColor || theme.palette.primary.main;
  const uncheckedBgColor = uncheckedColor || theme.palette.background.light;
  const disabledBgColor = disabledColor || theme.palette.primary.main;

  const uncheckedHoverBgColor = uncheckedColor
    ? theme.palette.grey[300]
    : theme.palette.background.darker;

  return {
    width: 48,
    height: 24,
    padding: 0,
    [`& .${switchClasses.switchBase}`]: {
      padding: 0,
      margin: theme.spacing(0.5),
      transitionDuration: '300ms',
      [`&.${switchClasses.checked}`]: {
        transform: 'translateX(24px)',
        [`& .${switchClasses.thumb}`]: {
          backgroundColor: theme.palette.common.white,
        },
        color: theme.palette.common.white,
        [`& + .${switchClasses.track}`]: {
          backgroundColor: checkedBgColor,
          opacity: 1,
          border: 0,
        },
        [`&.${switchClasses.disabled} + .${switchClasses.track}`]: {
          opacity: 0.5,
          backgroundColor: disabledBgColor,
        },
        [`&:hover + .${switchClasses.track}`]: {
          backgroundColor: checkedBgColor,
        },
        [`&:focus + .${switchClasses.track}`]: {
          border: `2px solid ${checkedBgColor}`,
        },
      },
      [`&.Mui-focusVisible .${switchClasses.thumb}`]: {
        color: theme.palette.primary.main,
        border: `6px solid ${theme.palette.common.white}`,
      },
      [`&.${switchClasses.disabled} .${switchClasses.thumb}`]: {
        color: theme.palette.grey[100],
      },
      [`&.${switchClasses.disabled} + .${switchClasses.track}`]: {
        opacity: 0.5,
      },
    },
    [`& .${switchClasses.thumb}`]: {
      boxSizing: 'border-box',
      width: 20,
      backgroundColor: theme.palette.grey[300],
      height: 20,
    },

    [`& .${switchClasses.track}`]: {
      borderRadius: theme.spacing(4),
      backgroundColor: uncheckedBgColor,
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
      '&:hover': {
        backgroundColor: uncheckedHoverBgColor,
      },
      '&:focus': {
        border: `2px solid ${theme.palette.primary.main}`,
      },
      [`&.${switchClasses.disabled}`]: {
        backgroundColor: disabledColor || theme.palette.background.light,
        opacity: 0.5,
      },
    },
  };
});
